<template>
    <transition name="modal">
        <div 
            v-if="objDisclaimer != null && objDisclaimer?.Abrir" 
            class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
            @click.self="closeModal"
        >
            <div class="relative w-full max-w-lg bg-white dark:bg-slate-800 rounded-xl shadow-2xl overflow-hidden">
                <!-- Header -->
                <div class="flex items-center gap-3 px-6 py-4 border-b border-gray-200 dark:border-slate-700">
                    <svg class="w-6 h-6 text-blue-600 dark:text-blue-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                        <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"/>
                    </svg>
                    <h2 class="text-lg font-semibold text-gray-900 dark:text-gray-100 flex-1" :title="titulo">
                        {{ titulo }}
                    </h2>
                    <button 
                        @click="closeModal"
                        class="p-1 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors"
                    >
                        <svg class="w-5 h-5 text-gray-500 dark:text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                        </svg>
                    </button>
                </div>

                <!-- Content -->
                <div class="px-6 py-4 max-h-96 overflow-y-auto border-b border-gray-200 dark:border-slate-700">
                    <div 
                        class="text-sm text-gray-700 dark:text-gray-300 leading-relaxed"
                        v-html="conteudo"
                    ></div>
                </div>

                <!-- Footer -->
                <div class="px-6 py-4 bg-gray-50 dark:bg-slate-900/50">
                    <button 
                        @click="closeModal"
                        class="w-full px-4 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
                    >
                        Entendi
                    </button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    computed: {
        ...mapGetters({
            objDisclaimer: "GET_MODAL_DISCLAIMER_INFORMATIVO",
            listaDisclaimer: "GET_LISTA_DISCLAIMER",
            user: 'auth/user',
        }),
    },
    data() {
        return {
            titulo: '',
            conteudo: '',
        };
    },
    methods: {
        closeModal() {
            this.$store.commit("SET_MODAL_DISCLAIMER_INFORMATIVO", false);
        },
    },
    watch: {
        objDisclaimer(){
            if(this.objDisclaimer != null && this.objDisclaimer.Abrir == true){
            if(this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente&& disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao) != null){
                var obj = this.listaDisclaimer.find(disclaimer => disclaimer.TipoCliente == this.objDisclaimer.TipoCliente
                && disclaimer.Secao == this.objDisclaimer.Sessao && disclaimer.SubSecao == this.objDisclaimer.SubSessao);
                this.titulo = obj.Titulo;
                this.conteudo = obj.Texto;

          }else{
                this.titulo = 'Sem informações adicionais';
                this.conteudo = 'Não há instruções adicionais para essa sessão';
          }
            }


        }
    }
};
</script>

<style scoped>
/* Modal transitions */
.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
    opacity: 0;
}

.modal-enter-active > div,
.modal-leave-active > div {
    transition: transform 0.3s ease;
}

.modal-enter-from > div,
.modal-leave-to > div {
    transform: scale(0.95);
}

/* Scrollbar styling for content */
.max-h-96::-webkit-scrollbar {
    width: 8px;
}

.max-h-96::-webkit-scrollbar-track {
    @apply bg-gray-100 dark:bg-slate-700 rounded;
}

.max-h-96::-webkit-scrollbar-thumb {
    @apply bg-gray-300 dark:bg-slate-600 rounded;
}

.max-h-96::-webkit-scrollbar-thumb:hover {
    @apply bg-gray-400 dark:bg-slate-500;
}
</style>
